// this is for the view only version
import React from "react";
import BaseModalV2 from "../base_modal_v2";
import { SummaryPage } from "./summary_page";
import get from "lodash/get";
import { matchPath } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useComponentDidMount } from "../../../lib/hook";
import { getCampaign } from "../../../action_managers/campaigns";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";

const CampaignSummaryView = ({ history, closeModal }) => {
  const campaignUUID = get(
    matchPath(window.location.pathname, "/campaigns/:campaignUUID/view"),
    "params.campaignUUID"
  );

  const dispatch = useDispatch();
  useComponentDidMount(() => {
    dispatch(getCampaign(campaignUUID));
  });
  const campaign = useSelector(state => state.campaigns.campaigns[campaignUUID]);
  const isLoading = useSelector(state => state.campaigns.isLoading);
  return (
    <BaseModalV2
      close={() => {
        closeModal();
        history.push(`/campaigns/${campaignUUID}`);
      }}
      title={"Campaign Summary"}
      isLoading={isLoading}
      showContent={true}
      hideFooter
      Content={
        <Grid fluid>
          <Row>
            <Col xs={10} smOffset={1}>
              <SummaryPage campaign={campaign} isViewPage={true} />
            </Col>
          </Row>
        </Grid>
      }
    />
  );
};

export default CampaignSummaryView;
